/* Product landing page (sections/gd-pdp.liquid): gallery + zoom, size buttons, add to cart, event timing. */
(function () {
  'use strict';

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.25"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.25"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.25"/></svg>'
  };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-gd-gallery]');
    if (!gallery) return;
    var slides = [].slice.call(gallery.querySelectorAll('[data-gd-slide]'));
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-gd-thumb]'));
    var count = gallery.querySelector('[data-gd-count]');
    var stage = gallery.querySelector('.gd-pdp__stage');
    var current = 0;
    if (!slides.length) return;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === current;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.tabIndex = on ? 0 : -1;
        if (on) { var img = s.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; }
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === current);
        if (k === current && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
      if (count) count.textContent = pad(current + 1);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = gallery.querySelector('[data-gd-prev]'), next = gallery.querySelector('[data-gd-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    gallery.addEventListener('keydown', function (e) {
      if (e.target.closest('input')) return;
      if (e.key === 'ArrowLeft') { show(current - 1); }
      if (e.key === 'ArrowRight') { show(current + 1); }
    });

    var sx = null, sy = null, swiped = false;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(current + (dx < 0 ? 1 : -1)); }
      sx = null;
    });

    var zoom = makeZoom(slides.map(function (s) { return { src: s.getAttribute('data-zoom-src'), alt: (s.querySelector('img') || {}).alt || '' }; }), function (i) { show(i); });
    slides.forEach(function (s, k) {
      s.addEventListener('click', function () { if (swiped) { swiped = false; return; } zoom.open(k); });
    });
  }

  function makeZoom(items, onChange) {
    var el = document.createElement('div');
    el.className = 'gd-pdp-zoom';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image zoom');
    el.innerHTML =
      '<div class="gd-pdp-zoom__frame"><img alt=""></div>' +
      '<button type="button" class="gd-pdp-zoom__btn gd-pdp-zoom__close" aria-label="Close">' + ICON.close + '</button>' +
      (items.length > 1 ? '<button type="button" class="gd-pdp-zoom__btn gd-pdp-zoom__prev" aria-label="Previous image">' + ICON.prev + '</button>' +
        '<button type="button" class="gd-pdp-zoom__btn gd-pdp-zoom__next" aria-label="Next image">' + ICON.next + '</button>' +
        '<span class="gd-pdp-zoom__count"></span>' : '');
    document.body.appendChild(el);
    var frame = el.querySelector('.gd-pdp-zoom__frame'), img = frame.querySelector('img'), counter = el.querySelector('.gd-pdp-zoom__count');
    var i = 0, opener = null, tx = null, ty = null;

    function render() {
      el.classList.remove('is-zoomed');
      img.src = items[i].src; img.alt = items[i].alt;
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(items.length);
    }
    function go(d) { i = (i + d + items.length) % items.length; render(); onChange(i); }
    function close() { el.hidden = true; document.documentElement.classList.remove('gd-pdp-noscroll'); if (opener) opener.focus(); }
    function origin(x, y) {
      var r = frame.getBoundingClientRect();
      img.style.transformOrigin = ((x - r.left) / r.width * 100) + '% ' + ((y - r.top) / r.height * 100) + '%';
    }
    frame.addEventListener('click', function (e) {
      if (el.classList.contains('is-zoomed')) { el.classList.remove('is-zoomed'); return; }
      origin(e.clientX, e.clientY); el.classList.add('is-zoomed');
    });
    frame.addEventListener('mousemove', function (e) { if (el.classList.contains('is-zoomed')) origin(e.clientX, e.clientY); });
    frame.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    frame.addEventListener('touchmove', function (e) {
      if (el.classList.contains('is-zoomed')) { e.preventDefault(); origin(e.touches[0].clientX, e.touches[0].clientY); }
    }, { passive: false });
    frame.addEventListener('touchend', function (e) {
      if (tx === null || el.classList.contains('is-zoomed') || items.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { e.preventDefault(); go(dx < 0 ? 1 : -1); }
      tx = null;
    });
    el.querySelector('.gd-pdp-zoom__close').addEventListener('click', close);
    var p = el.querySelector('.gd-pdp-zoom__prev'), n = el.querySelector('.gd-pdp-zoom__next');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && items.length > 1) go(-1);
      if (e.key === 'ArrowRight' && items.length > 1) go(1);
    });
    return {
      open: function (k) {
        opener = document.activeElement; i = k; render();
        el.hidden = false; document.documentElement.classList.add('gd-pdp-noscroll');
        el.querySelector('.gd-pdp-zoom__close').focus();
      }
    };
  }

  /* ---------- Sizes + cart ---------- */
  function initForm(root) {
    var form = root.querySelector('[data-gd-form]');
    if (!form) return;
    var data = root.querySelector('[data-gd-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var groups = [].slice.call(form.querySelectorAll('[data-gd-option]'));
    var idInput = form.querySelector('[data-gd-variant-input]');
    var price = root.querySelector('[data-gd-price]'), compare = root.querySelector('[data-gd-compare]');
    var add = form.querySelector('[data-gd-add]');
    var dpb = form.querySelector('[data-gd-dpb]');
    var msg = form.querySelector('[data-gd-message]');
    var addLabel = add ? add.textContent : '';
    var soldOut = (msg && msg.getAttribute('data-sold-out')) || 'Sold out';
    var shownPrice = price ? price.getAttribute('data-gd-price') : '';

    function say(html, isError) {
      if (!msg) return;
      msg.innerHTML = html; msg.hidden = false;
      msg.classList.toggle('is-error', !!isError);
    }
    function selection() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function match(sel) {
      if (sel.some(function (v) { return v === null; })) return null;
      for (var k = 0; k < variants.length; k++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) if (variants[k].options[j] !== sel[j]) { ok = false; break; }
        if (ok) return variants[k];
      }
      return null;
    }
    function markAvailability(sel) {
      groups.forEach(function (g, gi) {
        [].forEach.call(g.querySelectorAll('input'), function (input) {
          var trial = sel.slice(); trial[gi] = input.value;
          var any = variants.some(function (v) {
            for (var j = 0; j < trial.length; j++) if (trial[j] !== null && v.options[j] !== trial[j]) return false;
            return v.available;
          });
          input.closest('.gd-pdp__size').classList.toggle('is-unavailable', !any);
        });
      });
    }
    function update(fromUser) {
      var sel = selection();
      var v = match(sel);
      markAvailability(sel);
      if (v) {
        idInput.value = v.id;
        if (price && v.price !== shownPrice) { price.innerHTML = v.price; shownPrice = v.price; }
        if (compare) { compare.hidden = !v.compare; if (v.compare) compare.innerHTML = v.compare; }
        if (add) { add.disabled = !v.available; add.textContent = v.available ? addLabel : soldOut; }
        if (dpb) { if (v.available) dpb.removeAttribute('data-locked'); else dpb.setAttribute('data-locked', ''); }
        if (fromUser && window.history && history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString());
        }
        groups.forEach(function (g) { g.classList.remove('is-missing'); });
        if (fromUser && msg && !msg.hidden && msg.classList.contains('is-error')) msg.hidden = true;
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    update(false);

    function missing() {
      var sel = selection();
      var first = null;
      groups.forEach(function (g, k) { var m = sel[k] === null; g.classList.toggle('is-missing', m); if (m && !first) first = g; });
      if (first) {
        var name = (first.querySelector('legend') || {}).textContent || 'a size';
        say('Please ' + esc(name.toLowerCase()) + ' first.', true);
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
      return false;
    }
    var cover = form.querySelector('[data-gd-dpb-cover]');
    if (cover) cover.addEventListener('click', function () { missing(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (groups.length && missing()) return;
      if (!add || add.disabled) return;
      add.classList.add('is-busy'); add.textContent = 'Adding…';
      var body = new FormData(form);
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) { say(esc(res.j.description || res.j.message || 'Sorry, this could not be added to your cart.'), true); return; }
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        say('Added to your cart. <a href="' + root + 'cart">View cart</a> or <a href="' + root + 'checkout">check out</a>.', false);
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          [].forEach.call(document.querySelectorAll('.cart-count-number'), function (n) { n.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
      }).catch(function () {
        form.submit();
      }).then(function () {
        add.classList.remove('is-busy'); add.textContent = addLabel;
      });
    });
  }

  /* ---------- WhatsApp (store chat pop-up when present) ---------- */
  function openChat(root, text) {
    if (!root.hasAttribute('data-gd-chat-popup')) return false;
    var btn = document.getElementById('pushdaddy-button');
    var widget = document.getElementById('pushdaddy-widget');
    var box = document.getElementById('pushdaddy-response-message');
    if (!btn || !box) return false;
    if (!widget || !widget.classList.contains('pushdaddy-opened')) btn.click();
    setTimeout(function () {
      box.value = text;
      box.dispatchEvent(new Event('input', { bubbles: true }));
      try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    }, 350);
    return true;
  }
  function initWhatsApp(root) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gd-wa]');
      if (!a || !root.contains(a)) return;
      if (openChat(root, a.getAttribute('data-gd-wa'))) e.preventDefault();
    });
  }

  /* ---------- Size chart (Avada app) ---------- */
  function initSizeChart(root) {
    var fit = root.querySelector('.gd-pdp__fitnote a, .gd-pdp__links a');
    [].forEach.call(root.querySelectorAll('[data-gd-size-chart]'), function (b) {
      b.addEventListener('click', function () {
        var app = document.querySelector('.gd-pdp__avada [role="button"], .gd-pdp__avada .Avada-inline-button, #Avada-SC-button [role="button"]');
        if (app) { app.click(); return; }
        if (fit) fit.click();
      });
    });
  }

  /* ---------- Event timing ---------- */
  function initEvent(root) {
    var box = root.querySelector('[data-gd-event]');
    if (!box) return;
    var input = box.querySelector('[data-gd-event-date]'), out = box.querySelector('[data-gd-event-result]');
    var lead = (root.getAttribute('data-lead') || '').toLowerCase();
    var wa = root.getAttribute('data-wa-timing');
    var today = new Date(); today.setHours(0, 0, 0, 0);
    input.min = today.getFullYear() + '-' + pad(today.getMonth() + 1) + '-' + pad(today.getDate());

    var nums = (lead.match(/\d+/g) || []).map(Number);
    var unitDays = /day/.test(lead) && !/week/.test(lead) ? 1 : 7;
    var maxMake = nums.length ? Math.max.apply(null, nums) * unitDays : 0;
    var makeText = nums.length ? (nums.length > 1 ? Math.min.apply(null, nums) + '–' + Math.max.apply(null, nums) : nums[0]) + (unitDays === 1 ? ' days' : (nums[nums.length - 1] === 1 ? ' week' : ' weeks')) : '';
    var TRANSIT = 10, SLACK = 14;
    var makeVerb = unitDays === 1 ? ' to dispatch' : ' to make';
    var leadLabel = unitDays === 1 ? 'listed delivery time' : 'listed made-to-order time';

    function fmt(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }); }
    function show(html, tight) { out.innerHTML = html; out.hidden = false; out.classList.toggle('is-tight', !!tight); }
    var link = ' <a href="' + esc(wa) + '" target="_blank" rel="noopener" data-gd-wa="' + esc(root.getAttribute('data-wa-timing-text') || '') + '">Ask us about timing ↗</a>';

    box.querySelector('[data-gd-event-check]').addEventListener('click', function () {
      if (!input.value) { show('Please choose your event date first.', true); input.focus(); return; }
      var p = input.value.split('-');
      var d = new Date(+p[0], +p[1] - 1, +p[2]);
      var days = Math.round((d - today) / 864e5);
      if (days < 0) { show('That date has already passed. Please choose a future date.', true); return; }
      if (!maxMake) { show('Please confirm timing for ' + esc(fmt(d)) + ' with us before ordering.' + link, false); return; }
      var need = maxMake + TRANSIT;
      if (days < need) {
        show('<strong>This may be tight.</strong> The ' + leadLabel + ' is ' + esc(makeText) + ', and transit can take up to ' + TRANSIT + ' days, so the piece may not reach you by ' + esc(fmt(d)) + '. Please speak to us before ordering.' + link, true);
      } else if (days < need + SLACK) {
        show('<strong>Possible, but close.</strong> On the listed timelines (' + esc(makeText) + makeVerb + ', then 2–' + TRANSIT + ' days in transit) the piece should arrive shortly before ' + esc(fmt(d)) + ', with little margin. Please confirm with us before ordering.' + link, true);
      } else {
        show('<strong>That should work.</strong> On the listed timelines (' + esc(makeText) + makeVerb + ', then 2–' + TRANSIT + ' days in transit) ' + esc(fmt(d)) + ' leaves time to spare. Please still confirm the timing with us when you order.' + link, false);
      }
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); box.querySelector('[data-gd-event-check]').click(); } });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-gd-pdp]'), function (root) {
      if (root.__gdPdp) return; root.__gdPdp = true;
      initGallery(root); initForm(root); initSizeChart(root); initEvent(root); initWhatsApp(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
